import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';

export function StaffPicksCarousel(props) {
  const { loading, products } = useDispensaryProducts({
    filters: {
      sortBy: `popularSortIdx`,
      staffPicks: true,
    },
    perPage: 25,
  });
  // Optional caller-supplied heading, used by the CMS Product Carousel block.
  // Deliberately not read off `section.label` (which the homepage already passes):
  // honouring that would retitle live homepages for stores whose saved section
  // carries a custom label.
  const title = props?.title ?? `Staff Picks`;

  if (!products?.length && !loading) {
    return null;
  }

  return (
    <ProductCarousel
      products={products}
      isLoading={loading}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={title}
    />
  );
}
